"use strict";

// image-hover-popup with addClass
document.addEventListener("DOMContentLoaded", (event) => {
  const pointIngredients = document.querySelectorAll(".hover-point-ingredients");
  const pointGutFriendly = document.querySelectorAll(".hover-point-gut-friendly");
  const pointDietitianEndorsed = document.querySelectorAll(".hover-point-dietitian-endorsed");

  pointIngredients.forEach((el) => {
    el.addEventListener("mouseover", (e) => {
      e.target.closest(".image-hover-popup-content").classList.add("active-ingredients-image");
    });
    el.addEventListener("mouseout", (e) => {
      e.target.closest(".image-hover-popup-content").classList.remove("active-ingredients-image");
    });
  });
  pointGutFriendly.forEach((el) => {
    el.addEventListener("mouseover", (e) => {
      e.target.closest(".image-hover-popup-content").classList.add("active-gut-friendly-image");
    });
    el.addEventListener("mouseout", (e) => {
      e.target.closest(".image-hover-popup-content").classList.remove("active-gut-friendly-image");
    });
  });
  pointDietitianEndorsed.forEach((el) => {
    el.addEventListener("mouseover", (e) => {
      e.target.closest(".image-hover-popup-content").classList.add("active-dietitian-endorsed-image");
    });
    el.addEventListener("mouseout", (e) => {
      e.target.closest(".image-hover-popup-content").classList.remove("active-dietitian-endorsed-image");
    });
  });
});

// Tab menu
function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}

// Get the element with id="defaultOpen" and click on it
document.getElementById("defaultOpen").click();

  
  
  
  
  
  
